import { render, staticRenderFns } from "./factura.vue?vue&type=template&id=54448478&lang=html"
import script from "./factura.vue?vue&type=script&lang=js"
export * from "./factura.vue?vue&type=script&lang=js"
import style0 from "./factura.vue?vue&type=style&index=0&id=54448478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports